import { Component, OnInit } from '@angular/core';
import { WizardStep } from '../../../../wizard/wizard.component';
import { OrderBatchLogisticsWizardService } from '../../../../services/wizard/logistic/order-batch-send-wizard.service';
import { CacheFilterService } from '../../../../services/cache/cache-filter.service';
import { SectorFilter } from '../../../../model/sector-filter';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { FilterCompleteService } from 'src/app/filter-complete/filter-complete';
import { StudyReportSendWizardService } from '../../../../services/wizard/logistic/study-report-send-wizard';

@Component({
  selector: 'app-send-study-report-logistics-detail',
  templateUrl: './send-study-report-logistics-detail.component.html',
  styleUrls: ['./send-study-report-logistics-detail.component.css']
})
export class SendStudyReportLogisticsDetailComponent implements OnInit, WizardStep {
  isInit: boolean;
  form: FormGroup;
  sectors: SectorFilter[];
  filterCompleteSectorSend: FilterCompleteService<SectorFilter>;
  filterCompleteSectorReceiver: FilterCompleteService<SectorFilter>;
  constructor(private cacheFilterService: CacheFilterService
    , private formBuilder: FormBuilder
    , private studyReportSendWizardService: StudyReportSendWizardService) {

    this.createForm();
  }

  private createForm() {
    this.form = this.formBuilder.group({
      Description: [''],
      Name: ['', [Validators.required]],
      CreateDate: [''],
      DeliveryDate: [''],
      ReceptionDate: [{ value: '', disabled: this.studyReportSendWizardService.isReceiving() }, [Validators.required]],
      DeleteDate: [''],
      UpdateDate: [''],
      Deleted: [''],
      Id: [''],
      BatchStateId: [''],
      SectorSend: [{ value: '', disabled: true }, [Validators.required]],
      SectorReceiver: [{ value: '', disabled: this.studyReportSendWizardService.isReceiving() }, [Validators.required]],
      CreateUser: [''],
      PlanId: [''],
      TaxId: [''],
      EntityId: [''],
      UpdateUser: [''],
      DeleteUser: [''],
    });
    this.filterCompleteSectorSend = new FilterCompleteService<SectorFilter>([], this.f.SectorSend);
    this.filterCompleteSectorReceiver = new FilterCompleteService<SectorFilter>([], this.f.SectorReceiver);
  }

  get valid(): boolean {
    return this.completed;
  }

  get completed(): boolean { return this.form.valid; }
  get f() { return this.form.controls; }
  get filteredSectorReceiverOptions() { return this.filterCompleteSectorReceiver ? this.filterCompleteSectorReceiver.filteredOptions : []; }
  get filteredSectorSendOptions() { return this.filterCompleteSectorSend ? this.filterCompleteSectorSend.filteredOptions : []; }

  activate(): void {
    this.createForm();
    const studyReportBatchEditInfo = this.studyReportSendWizardService.getStudyReportBatchEditInfo();
    this.form.patchValue({
      Description: studyReportBatchEditInfo.StudyReportBatch.Description,
      Name: studyReportBatchEditInfo.StudyReportBatch.Name,
      CreateDate: studyReportBatchEditInfo.StudyReportBatch.CreateDate,
      DeliveryDate: studyReportBatchEditInfo.StudyReportBatch.DeliveryDate,
      ReceptionDate: studyReportBatchEditInfo.StudyReportBatch.ReceptionDate,
      DeleteDate: studyReportBatchEditInfo.StudyReportBatch.DeleteDate,
      UpdateDate: studyReportBatchEditInfo.StudyReportBatch.UpdateDate,
      Deleted: studyReportBatchEditInfo.StudyReportBatch.Deleted,
      Id: studyReportBatchEditInfo.StudyReportBatch.Id,
      BatchStateId: studyReportBatchEditInfo.StudyReportBatch.BatchStateId,
      SectorSend: studyReportBatchEditInfo.StudyReportBatch.SectorSend,
      SectorReceiver: studyReportBatchEditInfo.StudyReportBatch.SectorReceiver,
      CreateUser: studyReportBatchEditInfo.StudyReportBatch.CreateUser,
      UpdateUser: studyReportBatchEditInfo.StudyReportBatch.UpdateUser,
      DeleteUser: studyReportBatchEditInfo.StudyReportBatch.DeleteUser,
    });

    this.cacheFilterService.getSectorFilters().then((sectorFilters) => {
      this.sectors = sectorFilters;
      this.filterCompleteSectorSend = new FilterCompleteService<SectorFilter>(this.sectors, this.f.SectorSend);
      this.filterCompleteSectorReceiver = new FilterCompleteService<SectorFilter>(this.sectors, this.f.SectorReceiver);
    });

    this.form.valueChanges.subscribe(() => {
      this.studyReportSendWizardService.setStudyReportBatch(
        this.form.getRawValue()
      );
    });
  }

  save(): void {

  }

  ngOnInit(): void {
    this.isInit = true;
  }
}
